import { darkColors } from '@tryhackme/thm-ui-components';
import { ThemeProvider, useTheme } from 'styled-components';
import { Countdown } from '../../components/countdown';
import { useActiveCampaign } from '../../hooks/use-active-campaign';
import { StyledCard, StyledTimerMessage, StyledTitle } from './account-card.styles';
export const CybersecurityAwarenessAccountCard = () => {
  const theme = useTheme();
  const {
    campaign
  } = useActiveCampaign();
  if (!campaign) return null;
  return <ThemeProvider theme={{
    ...theme,
    colors: darkColors
  }} data-sentry-element="ThemeProvider" data-sentry-component="CybersecurityAwarenessAccountCard" data-sentry-source-file="account-card.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="account-card.tsx">
        <StyledTitle data-testid="campaign-account-card" data-sentry-element="StyledTitle" data-sentry-source-file="account-card.tsx">
          Cyber awareness month deal: <span>5 months free</span> on annual subscriptions
        </StyledTitle>
        <StyledTimerMessage data-sentry-element="StyledTimerMessage" data-sentry-source-file="account-card.tsx">Sale ends in:</StyledTimerMessage>
        <Countdown dark vertical endTime={campaign.endTime} data-sentry-element="Countdown" data-sentry-source-file="account-card.tsx" />
      </StyledCard>
    </ThemeProvider>;
};